import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import ModalFooter from './ModelFooter';
const ModalComponent = ({
  onModalToggle,
  isModalOpen = false,
  modalHeaderText,
  children,
  // modalFooter key here
  isFooterOpen = false,
  footerLoader = false,
  footerLoadingText = '',
  footerButtonText = '',
  footerButtonCancelText = '',
  onSubmitButton,
}) => {
  return (
    <Modal size='xs' isOpen={isModalOpen} toggle={onModalToggle} className={`modal-primary `}>
      <ModalHeader>
        {modalHeaderText}{' '}
        <Button className='close' color='secondary' onClick={onModalToggle}>
          ×
        </Button>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      {isFooterOpen && (
        <ModalFooter
          footerLoader={footerLoader}
          onModalToggle={onModalToggle}
          footerLoadingText={footerLoadingText}
          footerButtonText={footerButtonText}
          onSubmitButton={onSubmitButton}
          footerButtonCancelText={footerButtonCancelText}
        />
      )}
    </Modal>
  );
};
export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/ModalComponent/ModalComponent.js